import { Navigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

export const RedirectToWorkScheduleListPage = () => {
  const { navigation } = useNavigation()

  const to = navigation.settings.workSchedule.fullPath()

  return <Navigate to={to} />
}
